//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 

    import cmBlank from '@/components/cmBlank';
    import cmLoadmore from '@/components/cmLoadmore.vue'

    export default {
         components: {
            cmBlank,cmLoadmore
        },
        data(){
            return {
                i:0,
                number:0,
                keyword:'',
                blankShow:false,
                loadStatus:false,
                loadmoreText:'正在加载。。。',
                busy:false,
                list:[],
                where:[],
                hasNext:0,
                pageFlag:2,
                lastId:0,
                type:0,
                code:'',
            }
        },
        mounted(){
            this.i = Number(this.$route.params.i);
            this.type = Number(this.$route.params.type);
            this.$api.factoryData({type:this.type}).then((res)=>{
                switch(parseInt(this.i)){
                    case 1:
                        this.$route.meta.title = '待打包('+res.data.pack+')';
                        break;
                    case 2:
                        this.$route.meta.title = '待出厂('+res.data.out+')';
                        break;
                    default:
                        this.$route.meta.title = '待入厂('+(this.type > 0 ? res.data.yesterdayIn : res.data.in)+')';
                        this.number = this.type > 0 ? res.data.yesterdayIn : res.data.in;
                        break;
                }
                document.title = this.$route.meta.title;
            })
          
        },
        methods: {
            copy(val){
                this.$func.copy(val,event);
            },
            search(){
                this.list = [];
                this.lastId = 0;
                this.hasNext = 0;
                this.isActive = 0;
                this.loadmore();
            },
            getList(){
                this.$api.waitInFactory({last_id:this.lastId,page_flag:this.pageFlag,i:this.i,type:this.type,code:this.code}).then((res)=>{
                    if(res){
                        if(!this.lastId){
                            this.blankShow = res.data.length > 0 ? false : true;
                        }
                        this.hasNext = res.hasNext;
                        this.lastId = res.lastId;
                        res.data.forEach((item)=>{
                            this.list.push(item);
                        });
                    }
                })  
            },
            allInFactory(){
                let that = this;
                that.$func.confirm('确认 '+this.number+' 件已入厂？','提示',()=>{
                    that.$func.startLoading();
                     that.$api.alliInFactory({type:this.type,i:this.i}).then((res)=>{
                        if(res){
                            that.$func.endLoading();
                            that.search();
                            that.$func.showToast('操作成功');
                            wx.ready(function () {
                                let media = document.getElementById("musicBox");
                                media.src = "https://wash.uunbiot.com/uploads/default/operate.mp3"
                                media.play();
                            });
                        } 
                    });
                }) 
            },
            loadmore(){
                if(this.lastId > 0 && !this.hasNext){
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                    return ;
                }
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '正在加载。。。';
                this.getList();
                setTimeout(()=>{
                    if(this.blankShow){
                        this.busy = true;
                        this.loadStatus = false;
                        this.loadmoreText = '没有更多了。。。'
                    }else{
                        if(this.hasNext > 0){
                            this.loadStatus = false;
                            this.busy = false;
                        }else{
                            this.busy = true;
                            this.loadStatus = true;
                            this.loadmoreText = '没有更多了。。。'
                        }
                    }
                },1500)
            },
        },
    }



// WEBPACK FOOTER //
// ./src/pages/waitInFactory.vue